import { render, staticRenderFns } from "./PlayBanner.vue?vue&type=template&id=662ff20f&scoped=true&"
import script from "./PlayBanner.vue?vue&type=script&lang=js&"
export * from "./PlayBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlayBanner.vue?vue&type=style&index=0&id=662ff20f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ff20f",
  null
  
)

export default component.exports